import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import authService from './api-authorization/AuthorizeService';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
      isAuthenticated: false,
      claims: []
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const isAuthenticated = await authService.isAuthenticated();
    let claims = [];
    if (isAuthenticated) {
      const profile = await authService.getUser(); // returns user.profile (a map)
      claims = profile
        ? Object.entries(profile).flatMap(([type, value]) =>
            Array.isArray(value)
              ? value.map(v => ({ type, value: String(v) }))
              : [{ type, value: String(value) }])
        : [];
    }
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      claims
    }));
  }

  hasClaim(type, value) {
    return this.state.claims.some(c => c.type === type && c.value === value);
  }

  render() {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
          <NavbarBrand tag={Link} to="/">Enough</NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              {/*<NavItem>
                <NavLink tag={Link} className="text-dark" to="/fetch-data">Fetch data</NavLink>
              </NavItem>*/}
              {this.state.isAuthenticated && this.hasClaim("ViewWork", "true") &&
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Work
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem tag={Link} to="/work/currentpayperiod">Current Pay Period</DropdownItem>
                    <DropdownItem tag={Link} to="/work/workhistory">Work History</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem tag={Link} to="/work/payroll">Payroll</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>}
              {this.state.isAuthenticated && this.hasClaim("ViewGroceries", "true") &&
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Groceries
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem tag={Link} to="/groceries">Groceries</DropdownItem>
                    <DropdownItem tag={Link} to="/groceries/groceryhistory">Grocery History</DropdownItem>
                    <DropdownItem tag={Link} to="/groceries/groceryhistorybyitem">Grocery History (By Item)</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>}
              {this.state.isAuthenticated && this.hasClaim("ViewFinancialBasic", "true") &&
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                      Investments
                    </DropdownToggle>
                    <DropdownMenu end>
                    {this.state.isAuthenticated && this.hasClaim("ViewFinancialDetails", "true") &&
                      <DropdownItem tag={Link} to="/finances/summary">Summary</DropdownItem>
                    }
                    {this.state.isAuthenticated && this.hasClaim("ViewFinancialBasic", "true") &&
                      <DropdownItem tag={Link} to="/finances/accounts">Accounts</DropdownItem>
                    }
                    {this.state.isAuthenticated && this.hasClaim("ViewFinancialDetails", "true") &&
                      <>
                        <DropdownItem tag={Link} to="/finances/sales">Sales</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/withdrawals">Withdrawals</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/staking">Staking</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/tagged">Tagged Transactions</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/uploadinvestments">Upload Investments</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/matchwithdrawals">Match Sales and Withdrawals</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/matchdeposits">Match Deposits</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/compare">Compare Investments</DropdownItem>
                        <DropdownItem tag={Link} to="/finances/settings">Settings</DropdownItem>
                      </>
                    }
                    </DropdownMenu>
                </UncontrolledDropdown>}
              {this.state.isAuthenticated && this.hasClaim("ViewExpenses", "true") &&
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Expenses
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem tag={Link} to="/finances/expenses">Expenses</DropdownItem>
                    <DropdownItem tag={Link} to="/finances/uploadexpenses">Upload Expenses</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>}
              {this.state.isAuthenticated && this.hasClaim("ViewTodo", "true") &&
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                      Todo
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem tag={Link} to="/todo/dump">Dump</DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>}
              {this.state.isAuthenticated && this.hasClaim("ViewAlexaTest", "true") &&
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                      Alexa
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem tag={Link} to="/alexatest">Test</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>}
              <LoginMenu>
              </LoginMenu>
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
